import { render } from "./SeparatorEditorCmp.vue?vue&type=template&id=3c319f5b"
import script from "./SeparatorEditorCmp.vue?vue&type=script&lang=js"
export * from "./SeparatorEditorCmp.vue?vue&type=script&lang=js"

import "./SeparatorEditorCmp.vue?vue&type=style&index=0&id=3c319f5b&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__